import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import Flex from '../../../Flex';
import { useAppLayoutContext, useAppLayoutWidth, useContentContainerContext } from '../../hooks';

import { useClassNames } from './OuterLeftNav.styles';
import { shouldShowSubheaderAtWidth } from './SubHeaderRow';

// Avoids cyclic dependencies, value should match the outerLeftNavWidth in useLeftPanelWidth.tsx
const outerLeftNavWidth = 68;

const OuterLeftNav: FC<PropsWithChildren> = ({ children }) => {
  const classNames = useClassNames();
  const width = useAppLayoutWidth();
  const { shouldShowSubHeaderAtAllBreakpoints } = useContentContainerContext();
  const isLeftNavCollapsible = useAppLayoutContext()?.isLeftNavCollapsible ?? false;
  const isSubheaderDisplayedAtCurrentWidth = shouldShowSubheaderAtWidth(width, isLeftNavCollapsible);
  const shouldRender = children && !isSubheaderDisplayedAtCurrentWidth && !shouldShowSubHeaderAtAllBreakpoints;

  if (!shouldRender) {
    return null;
  }

  return (
    <Flex direction="column" shrink={0} width={outerLeftNavWidth} className={classNames.outerLeftNav}>
      {children}
    </Flex>
  );
};
export default OuterLeftNav;
